import { ResponsiveContainer, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, Tooltip, Legend } from "recharts";
import { ChartCard } from "./Card";
import { tokens } from "./styles";

// Your per-subject mastery vs the cohort average — the lateral comparison that
// shows strengths and gaps at a glance. Mastery is normalized, so it reflects
// all activity (including self-quizzes), unlike the standardized percentile.
export function radarVisible(data) {
  return Boolean(data?.available && data.subjects?.length);
}

export default function SubjectRadar({ data }) {
  if (!radarVisible(data)) return null;

  return (
    <ChartCard title="Subject mastery vs cohort" hint={`Cohort average across ${data.cohort_size} candidates`}>
      <ResponsiveContainer width="100%" height={300}>
        <RadarChart data={data.subjects} outerRadius="72%">
          <PolarGrid stroke={tokens.ink200} />
          <PolarAngleAxis dataKey="subject" tick={{ fontSize: 11, fill: tokens.ink500 }} />
          <PolarRadiusAxis domain={[0, 100]} tick={{ fontSize: 9, fill: tokens.ink400 }} angle={90} />
          <Radar name="Cohort avg" dataKey="cohort_avg" stroke={tokens.ink400} fill={tokens.ink300} fillOpacity={0.35} />
          <Radar name="You" dataKey="you" stroke={tokens.accent} fill={tokens.accent} fillOpacity={0.4} connectNulls />
          <Tooltip formatter={(value) => (value == null ? "—" : `${value}%`)} />
          <Legend wrapperStyle={{ fontSize: 12 }} />
        </RadarChart>
      </ResponsiveContainer>
    </ChartCard>
  );
}
